export default __webpack_public_path__ + "static/media/Rschool.e69bef9b.svg";